import { render, staticRenderFns } from "./TcmDetail.vue?vue&type=template&id=3a2266ec&scoped=true"
import script from "./TcmDetail.vue?vue&type=script&lang=js"
export * from "./TcmDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2266ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a2266ec')) {
      api.createRecord('3a2266ec', component.options)
    } else {
      api.reload('3a2266ec', component.options)
    }
    module.hot.accept("./TcmDetail.vue?vue&type=template&id=3a2266ec&scoped=true", function () {
      api.rerender('3a2266ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TCMRx/comp/TcmDetail.vue"
export default component.exports